import BaseDAO from '@/core/services/BaseDAO';

/**
 * DAO (Data Access Object) для работы с авторизацией и управлением доступом
 * Выполняет запросы к серверу для аутентификации и управления пользователями
 */
class AclDAO extends BaseDAO {

	/**
	 * Авторизация пользователя по email и паролю или коду
	 * @param {string} email - Email пользователя
	 * @param {string} password - Пароль пользователя (если авторизация по паролю)
	 * @param {string} code - Код авторизации (если авторизация по коду)
	 * @returns {Promise<{data: Object, meta: Object}>} Полный ответ с данными пользователя и мета-информацией
	 */
	static async login(email, password = null, code = null) {
		return await this.rpc.makeRequest('acl.login', {
			email,
			password,
			code
		});
	}

	/**
	 * Отправка кода авторизации на email
	 * @param {string} email - Email пользователя
	 * @returns {Promise<Object>} Только данные результата отправки кода
	 */
	static async sendLoginCode(email) {
		return (await this.rpc.makeRequest('acl.sendLoginCode', { email })).data;
	}

	/**
	 * Смена пароля пользователя
	 * FIXME: Эндпоинт не запрашивает текущий пароль - это проблема безопасности
	 * @param {string} newPassword - Новый пароль
	 * @returns {Promise<Object>} Результат смены пароля
	 */
	static async changePassword(newPassword) {
		return (await this.rpc.makeRequest('acl.changePassword', { password: newPassword }));
	}

	/**
	 * Получение данных текущего пользователя
	 * @returns {Promise<Object>} Данные текущего пользователя
	 */
	static async getCurrentUser() {
		return (await this.rpc.makeRequest('acl.getCurrentUser')).data;
	}

	/**
	 * Выход из системы (logout)
	 * FIXME: нет пока этого ендпоинта
	 * @returns {Promise<void>} Метод не возвращает данные
	 */
	static async logout() {
		//await this.rpc.makeRequest('acl.logout');
	}

	/**
	 * Сохранение отображаемой валюты для пользователя
	 * @param {string} currencyCode - Код валюты (например, 'RUB', 'USD')
	 * @returns {Promise<Object>} Только данные результата сохранения
	 */
	static async saveDisplayedCurrencyCode(currencyCode) {
		return (await this.rpc.makeRequest('acl.saveDisplayCurrencyCode', { currencyCode })).data;
	}

	/**
	 * Отправка письма-напоминалки пароля
	 * @param {string} email - Email пользователя
	 * @returns {Promise<Boolean>}
	 * */
	static async sendPassword(email) {
		return (await this.rpc.makeRequest('acl.sendPassword', { email })).data || false;
	}
}

export default AclDAO;
